import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import HelpIcon from '@material-ui/icons/Help';

export default function HelpButton() {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    window.location.href = 'mailto:support@centerline.co';
  };

  return (
    <IconButton onClick={handleClick} style={{ padding: 4 }}>
      <HelpIcon style={{ height: '21px', color: '#7A797A' }} />
      <span style={{ position: 'absolute', fontSize: '12px', top: 23 }}>HELP</span>
    </IconButton>
  );
}
